module.exports = __webpack_public_path__ + "static/media/people07.cc0cad16.png";